var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gtwm"},[(_vm.show)?_c('detailVue',{attrs:{"articleId":_vm.article_id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }